var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position: relative;" },
    [
      _c(
        "q-toolbar",
        {
          staticClass: "top-page-toolbar",
          staticStyle: {
            position: "fixed",
            top: "calc(69 + var(--top-offset, 0))px",
            left: "0",
            "z-index": "10",
            "box-shadow":
              "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)"
          },
          attrs: { color: "white", "text-color": "grey-9" }
        },
        [
          _c("q-toolbar-title"),
          _c(
            "div",
            [
              _c("q-btn", {
                staticClass: "q-mr-md",
                attrs: {
                  label: _vm.$t("preview"),
                  color: "tertiary",
                  flat: ""
                },
                on: { click: _vm.previewInvoice }
              }),
              _vm.editing && !_vm.editingDraft
                ? _c(
                    "q-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.createInvoice }
                    },
                    [_vm._v("\n        " + _vm._s(_vm.$t("save")) + "\n      ")]
                  )
                : _c(
                    "q-btn-dropdown",
                    {
                      attrs: {
                        label: _vm.$t("create"),
                        color: "primary",
                        split: ""
                      },
                      on: { click: _vm.createInvoice }
                    },
                    [
                      _c(
                        "q-list",
                        { attrs: { link: "" } },
                        [
                          _c(
                            "q-item",
                            {
                              directives: [
                                {
                                  name: "close-overlay",
                                  rawName: "v-close-overlay"
                                }
                              ]
                            },
                            [
                              _c(
                                "q-item-main",
                                [
                                  _c(
                                    "q-item-tile",
                                    {
                                      attrs: { label: "" },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.saveDraft($event)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("save_draft")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "layout-padding" }, [
        _c("section", { staticClass: "invoicing-create" }, [
          _c("header", [
            _vm.activeTeam.settings.logo_url
              ? _c("img", {
                  staticClass: "logo",
                  attrs: { src: _vm.activeTeam.settings.logo_url }
                })
              : _vm._e(),
            _c("span", {
              staticClass: "return-line",
              domProps: { innerHTML: _vm._s(_vm.returnLine) }
            }),
            _c(
              "div",
              { staticClass: "customer" },
              [
                _c("customer-select", {
                  attrs: {
                    types: _vm.customerTypes.ALL,
                    value: _vm.customer,
                    hasError: _vm.errors.has("customer"),
                    errorLabel: _vm.errors.first("customer"),
                    "inverted-light": "",
                    "hide-underline": ""
                  },
                  on: { input: _vm.updateCustomer }
                }),
                _vm.customer && _vm.customer.type === _vm.customerTypes.COMPANY
                  ? _c("customer-select", {
                      staticClass: "q-mt-sm",
                      attrs: {
                        types: [_vm.customerTypes.CONTACT_PERSON],
                        placeholder: _vm.$tc("contact_person", 1),
                        companyFilter: _vm.customerId,
                        hasErrors: _vm.errors.has("contactPerson"),
                        errorLabel: _vm.errors.first("contactPerson")
                      },
                      model: {
                        value: _vm.contactPerson,
                        callback: function($$v) {
                          _vm.contactPerson = $$v
                        },
                        expression: "contactPerson"
                      }
                    })
                  : _vm._e(),
                _vm.customer
                  ? _c("customer-address-select", {
                      staticClass: "q-mt-md",
                      attrs: { customer: _vm.customer },
                      on: { reFetchCustomer: _vm.handleReFetchCustomer },
                      model: {
                        value: _vm.invoiceAddresses,
                        callback: function($$v) {
                          _vm.invoiceAddresses = $$v
                        },
                        expression: "invoiceAddresses"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _c(
            "main",
            [
              _c("div", { staticClass: "row items-end" }, [
                _c(
                  "div",
                  { staticClass: "invoice-title" },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editTitle,
                            expression: "!editTitle"
                          }
                        ],
                        staticClass: "headline q-my-none",
                        on: { click: _vm.toggleInvoiceTitle }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.invoiceTitle) +
                            "\n            "
                        )
                      ]
                    ),
                    _c(
                      "q-field",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editTitle,
                            expression: "editTitle"
                          }
                        ],
                        staticClass: "q-ma-none headline-input",
                        attrs: {
                          error: _vm.errors.has("invoice_title"),
                          "error-label": _vm.errors.first("invoice_title")
                        }
                      },
                      [
                        _c("q-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "required|max:255",
                              expression: "'required|max:255'",
                              modifiers: { disable: true }
                            }
                          ],
                          ref: "invoiceTitleInput",
                          attrs: {
                            name: "invoice_title",
                            "data-vv-as": _vm.$t("invoice_title"),
                            placeholder: _vm.$t("invoice_title"),
                            disable: !_vm.editTitle,
                            autofocus: "",
                            "hide-underline": ""
                          },
                          on: {
                            blur: _vm.handleBlurInvoiceTitle,
                            keydown: function($event) {
                              if (
                                !("button" in $event) &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleBlurInvoiceTitle($event)
                            }
                          },
                          model: {
                            value: _vm.invoiceTitle,
                            callback: function($$v) {
                              _vm.invoiceTitle = $$v
                            },
                            expression: "invoiceTitle"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-tooltip",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editTitle,
                            expression: "!editTitle"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("click_to_edit")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "invoice-number" },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.generateInvoiceNumber,
                            expression: "generateInvoiceNumber"
                          }
                        ],
                        staticClass: "invoice-number-text",
                        on: { click: _vm.toggleInvoiceNumber }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.nextInvoiceNumber) +
                            "\n            "
                        )
                      ]
                    ),
                    _c(
                      "q-field",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.generateInvoiceNumber,
                            expression: "!generateInvoiceNumber"
                          }
                        ],
                        attrs: {
                          error: _vm.errors.has("invoice_number"),
                          "error-label": _vm.errors.first("invoice_number")
                        }
                      },
                      [
                        _c("q-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "max:255",
                              expression: "'max:255'",
                              modifiers: { disable: true }
                            }
                          ],
                          ref: "invoiceNumberInput",
                          attrs: {
                            name: "invoice_number",
                            prefix: "#",
                            "data-vv-as": _vm.$t("invoice_number"),
                            placeholder: _vm.$t("invoice_number"),
                            disable: _vm.generateInvoiceNumber,
                            after: [
                              {
                                icon: "cancel",
                                handler: function handler() {
                                  _vm.generateInvoiceNumber = true
                                  _vm.invoiceNumber = null
                                }
                              }
                            ],
                            autofocus: "",
                            "hide-underline": ""
                          },
                          on: { blur: _vm.checkInvoiceNumber },
                          model: {
                            value: _vm.invoiceNumber,
                            callback: function($$v) {
                              _vm.invoiceNumber = $$v
                            },
                            expression: "invoiceNumber"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-tooltip",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.generateInvoiceNumber,
                            expression: "generateInvoiceNumber"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("invoice_number_tooltip")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "invoice-meta q-mt-sm" },
                [
                  _c(
                    "q-field",
                    {
                      staticClass: "q-ma-none",
                      attrs: {
                        error: _vm.errors.has("invoiceDate"),
                        "error-label": _vm.errors.first("invoiceDate"),
                        label: _vm.$t("invoice_date"),
                        "label-width": 6
                      }
                    },
                    [
                      _c("q-datetime", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.disable",
                            value: "required",
                            expression: "'required'",
                            modifiers: { disable: true }
                          }
                        ],
                        attrs: {
                          type: "date",
                          name: "invoiceDate",
                          "hide-underline": "",
                          "data-vv-as": _vm.$t("invoice_date"),
                          placeholder: _vm.$t("invoice_date"),
                          format: _vm.$t("date_format")
                        },
                        on: { change: _vm.updateDueDate },
                        model: {
                          value: _vm.invoiceDate,
                          callback: function($$v) {
                            _vm.invoiceDate = $$v
                          },
                          expression: "invoiceDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "row justify-between" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-md-5 delivery-time-select"
                      },
                      [
                        _c("q-select", {
                          attrs: { options: _vm.deliveryTimeOptions },
                          model: {
                            value: _vm.deliveryPeriod,
                            callback: function($$v) {
                              _vm.deliveryPeriod = $$v
                            },
                            expression: "deliveryPeriod"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-md-6" },
                      [
                        _c(
                          "q-field",
                          {
                            staticClass: "q-ma-none",
                            attrs: {
                              error: _vm.errors.has("deliveryDate"),
                              "error-label": _vm.errors.first("deliveryDate")
                            }
                          },
                          [
                            _c("q-datetime", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate.disable",
                                  value: "required",
                                  expression: "'required'",
                                  modifiers: { disable: true }
                                }
                              ],
                              attrs: {
                                type: "date",
                                name: "deliveryDate",
                                "hide-underline": "",
                                "data-vv-as": _vm.$t(_vm.deliveryDateLabel),
                                placeholder: _vm.$t(_vm.deliveryDateLabel),
                                format: _vm.$t("date_format")
                              },
                              model: {
                                value: _vm.deliveryDate,
                                callback: function($$v) {
                                  _vm.deliveryDate = $$v
                                },
                                expression: "deliveryDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm.deliveryPeriod
                    ? _c(
                        "q-field",
                        {
                          staticClass: "q-ma-none",
                          attrs: {
                            error: _vm.errors.has("deliveryPeriodEnd"),
                            "error-label": _vm.errors.first(
                              "deliveryPeriodEnd"
                            ),
                            label: " ",
                            "label-width": 6
                          }
                        },
                        [
                          _c("q-datetime", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate.disable",
                                value: "required",
                                expression: "'required'",
                                modifiers: { disable: true }
                              }
                            ],
                            attrs: {
                              type: "date",
                              name: "deliveryPeriodEnd",
                              "hide-underline": "",
                              "data-vv-as": _vm.$t("end"),
                              placeholder: _vm.$t("end"),
                              format: _vm.$t("date_format")
                            },
                            model: {
                              value: _vm.deliveryPeriodEnd,
                              callback: function($$v) {
                                _vm.deliveryPeriodEnd = $$v
                              },
                              expression: "deliveryPeriodEnd"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "q-field",
                    {
                      staticClass: "q-ma-none",
                      attrs: {
                        error: _vm.errors.has("dueDate"),
                        "error-label": _vm.errors.first("dueDate"),
                        label: _vm.$t("due_date"),
                        "label-width": 6
                      }
                    },
                    [
                      _c("q-datetime", {
                        attrs: {
                          type: "date",
                          name: "dueDate",
                          "hide-underline": "",
                          clearable: "",
                          "data-vv-as": _vm.$t("due_date"),
                          placeholder: _vm.$t("due_date"),
                          format: _vm.$t("date_format")
                        },
                        model: {
                          value: _vm.dueDate,
                          callback: function($$v) {
                            _vm.dueDate = $$v
                          },
                          expression: "dueDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-field",
                    {
                      staticClass: "q-ma-none",
                      attrs: { label: _vm.$tc("project", 1), "label-width": 6 }
                    },
                    [
                      !_vm.hasMultipleProjects
                        ? _c(
                            "div",
                            [
                              _c("project-indicator", {
                                attrs: {
                                  project: _vm.projects
                                    ? _vm.projects[0]
                                    : undefined,
                                  clickable: ""
                                }
                              }),
                              _c("project-popover", {
                                attrs: {
                                  "active-project": _vm.projects
                                    ? _vm.projects[0]
                                    : undefined
                                },
                                on: {
                                  "select-project": _vm.handleSelectProject
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.projects, function(project, index) {
                              return _c("project-indicator", {
                                key: index,
                                attrs: { project: project }
                              })
                            })
                          )
                    ]
                  )
                ],
                1
              ),
              _c("add-textarea-box", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "max:100000",
                    expression: "'max:100000'",
                    modifiers: { disable: true }
                  }
                ],
                staticClass: "q-mt-xl",
                attrs: {
                  name: "noteTop",
                  placeholder: _vm.$t("note_top"),
                  "additional-box-text": _vm.$t("or_use_template"),
                  useMarkdown: ""
                },
                on: {
                  clicked: function($event) {
                    _vm.$refs.topTemplateModal.open()
                  }
                },
                model: {
                  value: _vm.noteTop,
                  callback: function($$v) {
                    _vm.noteTop = $$v
                  },
                  expression: "noteTop"
                }
              }),
              _vm._l(_vm.items[0].children, function(entry, index) {
                return _c("line-items", {
                  key: index,
                  ref: "itemsTable",
                  refInFor: true,
                  staticClass: "q-mt-xl",
                  attrs: {
                    value: entry,
                    currency: _vm.currency,
                    "show-heading-input": _vm.items[0].children.length > 1,
                    "show-delete-button": _vm.items[0].children.length > 1
                  },
                  on: {
                    deleteBlock: function($event) {
                      _vm.handleDeleteBlock(index)
                    },
                    deleteItem: function(itemIndex) {
                      return _vm.handleDeleteItem(index, itemIndex)
                    },
                    updateGroup: function(value) {
                      return _vm.handleUpdateGroup(index, value)
                    },
                    updateGroupHeading: function(value) {
                      return _vm.handleUpdateGroupHeading(index, value)
                    },
                    update: _vm.handleLineItemUpdate
                  }
                })
              }),
              _c(
                "div",
                { staticClass: "flex justify-center q-mt-lg" },
                [
                  !_vm.showItemForm
                    ? _c(
                        "q-btn-dropdown",
                        {
                          attrs: {
                            label: _vm.$t("new_line_item_button"),
                            color: "primary",
                            split: "",
                            outline: ""
                          },
                          on: { click: _vm.handleAddItemButton }
                        },
                        [
                          _c(
                            "q-list",
                            { attrs: { link: "" } },
                            [
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleAddLineItemsBlock($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("invoice_block_add"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.showItemForm
                ? _c("items-list-new-entry", {
                    staticClass: "q-mt-lg",
                    attrs: {
                      currency: _vm.currency,
                      "active-line-item": _vm.activeLineItem,
                      type: "invoice"
                    },
                    on: {
                      add: _vm.handleAddItem,
                      update: _vm.handleUpdateItem,
                      cancel: _vm.handleItemFormCancel
                    }
                  })
                : _vm._e(),
              _vm.errors.has("items")
                ? _c("div", { staticClass: "on-right" }, [
                    _c("span", { staticClass: "text-negative" }, [
                      _vm._v(_vm._s(_vm.$t("item_required")))
                    ])
                  ])
                : _vm._e(),
              _c("invoice-price-summary", {
                staticClass: "q-mt-xl",
                attrs: {
                  items: _vm.lineItems,
                  discount: _vm.discount,
                  cashDiscount: _vm.cashDiscount
                }
              }),
              _c(
                "div",
                { staticClass: "row justify-end q-mt-sm q-mb-xl" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { flat: "", outline: "" } },
                    [
                      _vm.discount === null
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                color: "grey-7",
                                flat: "",
                                outline: "",
                                dense: "",
                                "no-caps": ""
                              },
                              on: { click: _vm.addDiscount }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("add_discount")) +
                                  "\n            "
                              )
                            ]
                          )
                        : _c(
                            "q-btn",
                            {
                              attrs: {
                                color: "negative",
                                flat: "",
                                outline: "",
                                dense: "",
                                "no-caps": ""
                              },
                              on: { click: _vm.deleteDiscount }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("delete_discount")) +
                                  "\n            "
                              )
                            ]
                          ),
                      _vm.cashDiscount === null
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                color: "grey-7",
                                flat: "",
                                outline: "",
                                dense: "",
                                "no-caps": ""
                              },
                              on: { click: _vm.addCashDiscount }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("add_cash_discount")) +
                                  "\n            "
                              )
                            ]
                          )
                        : _c(
                            "q-btn",
                            {
                              attrs: {
                                color: "negative",
                                flat: "",
                                outline: "",
                                dense: "",
                                "no-caps": ""
                              },
                              on: { click: _vm.deleteCashDiscount }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("delete_cash_discount")) +
                                  "\n            "
                              )
                            ]
                          )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("add-textarea-box", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "max:100000",
                    expression: "'max:100000'",
                    modifiers: { disable: true }
                  }
                ],
                staticClass: "q-mt-xl",
                attrs: {
                  name: "noteBottom",
                  placeholder: _vm.$t("note_bottom"),
                  "additional-box-text": _vm.$t("or_use_template"),
                  useMarkdown: ""
                },
                on: {
                  clicked: function($event) {
                    _vm.$refs.bottomTemplateModal.open()
                  }
                },
                model: {
                  value: _vm.noteBottom,
                  callback: function($$v) {
                    _vm.noteBottom = $$v
                  },
                  expression: "noteBottom"
                }
              })
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c("q-collapsible", { attrs: { label: _vm.$t("options") } }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6" },
                    [
                      _c("language-input", {
                        attrs: { labelWidth: 3 },
                        model: {
                          value: _vm.language,
                          callback: function($$v) {
                            _vm.language = $$v
                          },
                          expression: "language"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ])
      ]),
      _c("text-template-modal", {
        ref: "topTemplateModal",
        attrs: { model: "invoice", initialPosition: "top" },
        on: {
          selected: function(text) {
            return (this$1.noteTop = text)
          }
        }
      }),
      _c("text-template-modal", {
        ref: "bottomTemplateModal",
        attrs: { model: "invoice", initialPosition: "bottom" },
        on: {
          selected: function(text) {
            return (this$1.noteBottom = text)
          }
        }
      }),
      _c("add-discount-dialog", {
        ref: "addDiscountDialog",
        attrs: { currency: _vm.currency },
        on: { discount: _vm.handleAddDiscount }
      }),
      _c("add-cash-discount-dialog", {
        ref: "addCashDiscountDialog",
        attrs: { invoiceDate: _vm.invoiceDate, dueDate: _vm.dueDate },
        on: { discount: _vm.handleAddCashDiscount }
      }),
      _c("preview-modal", {
        ref: "previewModal",
        attrs: { blob: _vm.previewBlob }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }